export const location = {
  uz: {
    locationTitle: "Bizning Klinikamiz <span>Manzili</span>",
    locationText:
      "Maxsus va juda yaqin narsa. Shunday qilib, biz doimo birga bo'lamiz. Viverra Mauris fringilla bilan bir xil",
    locationWorkingTime:
      "Dushanba - Shanba: 09:00 dan 19:00 gacha <br/> Yakshanba: 10:00 dan 16:00 gacha",
    locationAddressText: "Samarqand shahri, Mirzo Ulug'bek ko'chasi, 3",
    locationAddressText2:
      "Navoiy viloyati, Xatirchi tumani, Farxod ko’chasi, 1 uy",
    locationSamarkand: "Samarqand",
    locationXatirchi: "Xatirchi",
  },
  ru: {
    locationTitle: "<span>Расположение</span>  Наших Клиник",
    locationText:
      "Что-то особенное и что-то очень близкое. Так что мы будем вместе всегда. Виверра Маурис в одном лице с фрингильей",
    locationWorkingTime:
      "Пн - Сб: с 09:00 до 19:00 <br/> Воскресенье: с 10:00 до 16:00",
    locationAddressText: "город Самарканд, улица Мирзо Улугбека, 3",
    locationAddressText2: "область Навои, район Хатирчи, улица Фархад, дом 1",
    locationSamarkand: "Самарканд",
    locationXatirchi: "Хатирчи",
  },
  tj: {
    locationTitle: "Ҷойгиршавии <span>Клиникаи</span> Мо",
    locationText:
      "Чизи махсус ва чизи хеле наздик. Ҳамин тавр, мо ҳамеша якҷоя хоҳем буд. Виверра Маурис бо фрингилла яксон аст",
    locationWorkingTime:
      "Пн-Сб: аз соати 09:00 То 19:00 <br/> Якшанбе: аз соати 10:00 то 16:00",
    locationAddressText: "шаҳри Самарқанд, кӯчаи Мирзо Улуғбек, 3",
    locationAddressText2: "ноҳияи Намангон, ноҳияи Хатирчи, кӯчаи Фархад, хонаи 1",
    locationSamarkand: "Самарқанд",
    locationXatirchi: "Хатирчи",
  },
};
